<div *ngIf="currentToast"  [ngClass]="currentToast.type" class="toast">
  <div>{{currentToast.title}}</div>
  <div>{{currentToast.message}}</div>
</div>
